import styled from '@emotion/styled';

import { Gray_Light_100 } from '@common/styles';

export const Root = styled.div`
  border-radius: 8px;
  background-color: ${Gray_Light_100};
  overflow: hidden;
  position: relative;
  width: 80px;
  height: 96px;
`;

export const SlotContainer = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border-radius: inherit;
  background-color: rgba(0, 0, 0, 0.03);
  transform: translateZ(1px);
`;

export const ProductImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: inherit;
  object-fit: cover;
  opacity: 0;
  transition: opacity 300ms;

  &[data-load='complete'] {
    opacity: 1;
  }
`;

export const Slot = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;

  &.top-left {
    top: 6px;
    left: 6px;
  }

  &.top-right {
    top: 6px;
    right: 6px;
  }

  &.bottom-right {
    bottom: 6px;
    right: 6px;
  }

  &.bottom-left {
    bottom: 6px;
    left: 6px;
  }
`;
